(function () {
  "use strict";

  var observer;

  function fireEvent(scriptEl) {
    if (scriptEl.dataset.ga4Fired === "1") return;
    if (typeof gtag !== "function") return;

    try {
      var data = JSON.parse(scriptEl.textContent);
      if (!data.items || !data.items.length) return;

      // gtag("event", "view_item_list", {
      //   item_list_id: data.item_list_id,
      //   item_list_name: data.item_list_name,
      //   items: data.items,
      // });
      window.LeafCustomEvents.publish("view_item_list", {
        item_list_id: data.item_list_id,
        item_list_name: data.item_list_name,
        items: data.items,
      });

      scriptEl.dataset.ga4Fired = "1";
    } catch (e) {
      // Silently ignore parse errors
    }
  }

  function init() {
    var blocks = document.querySelectorAll(
      '.js-ga4-vil-data:not([data-ga4-fired="1"])'
    );
    if (!blocks.length) return;

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target.querySelector('.js-ga4-vil-data:not([data-ga4-fired="1"])');
            if (el) fireEvent(el);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0 }
      );
    }

    blocks.forEach(function (block) {
      var container = block.parentElement;
      if (container) observer.observe(container);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.ga4InitViewItemList = init;
})();
